export const en = {
    nav: {
        home: "Home",
        about: "About Us",
        services: "Services",
        contact: "Contact",
        consultation: "Consultation",
        subTitle: "Law & Consultancy",
        workingHours: "Mon - Fri: 09:00 - 18:00"
    },
    hero: {
        slides: [
            {
                title: "Professional Legal and Advocacy Services",
                description: "Years of extensive experience in the legal field"
            },
            {
                title: "High-End Corporate Legal Services",
                description: "Prevention, mitigation, and resolution of legal issues for your business"
            },
            {
                title: "Individual Approach to Every Client",
                description: "We prioritize the individual requirements and interests of each client"
            }
        ],
        btnConsultation: "Consultation",
        btnServices: "Services",
        stats: {
            yearsExp: "Years of Experience",
            cases: "Court Cases",
            successRate: "Successful Cases",
            confidentiality: "Confidentiality"
        }
    },
    marquee: "Protecting your rights is our mission.",
    home: {
        practiceTitle: "Practice Areas",
        practiceAreas: [
            {
                title: "Civil Law",
                description: "Protection of your rights and legitimate interests in any matter relating to private law"
            },
            {
                title: "Administrative Law",
                description: "Your legal defender in relations with government and administrative bodies."
            },
            {
                title: "Corporate Law",
                description: "Corporate legal maintenance for companies and effective resolution of any legal challenges"
            }
        ],
        btnMore: "Learn More",
        whyChooseUs: "Why Choose Us",
        learnMore: "Learn More",
        ctaTitle: "We Are Ready to Address All Your Legal Inquiries",
        ctaText: "Get in touch with our legal specialists today and receive professional consultation:",
        btnCallNow: "Call Now",
        btnSendMessage: "Send a Message",
        toastCallTitle: "Call Us",
        toastCallDesc: "Phone: +374 77 53 13 09"
    },
    about: {
        pageTitle: "About the Firm",
        pageSubtitle: "Since 2023, we provide professional legal and advocacy services in private law, administrative law, and corporate law.",
        stats: [
            { value: "5+", label: "Years of Experience" },
            { value: "200+", label: "Court Cases" },
            { value: "94%", label: "Successful Cases" }
        ],
        foundersTitle: "Founders of the Firm",
        team: [
            {
                name: "Aren V. Antonyan",
                role: "Co-founder, Attorney-at-Law",
                specialization: "Civil Law, Administrative Law, Corporate Law, Bankruptcy, Public Procurement",
                experience: "5 years",
                experienceLabel: "Experience"
            },
            {
                name: "Ashot A. Grigoryan",
                role: "Co-founder, Managing Director",
                specialization: "Civil Law, Administrative Law, Corporate Law, Bankruptcy, Intellectual Property Law",
                experience: "5 years",
                experienceLabel: "Experience"
            }
        ],
        btnViewDetails: "View Details",
        historyTitle: "Our History",
        historyP1: "The company was established in 2023. Since our inception, our lawyers and attorneys have vigorously defended the rights and interests of individuals and businesses.",
        historyP2: "Consequently, our clients have been thoroughly satisfied with the dedicated approach and high-level legal assistance provided.",
        historyP3: "We remain steadfast in our founding values: justice, diligence, and personalized attention to every single client.",
        valuesTitle: "Our Core Values",
        values: [
            {
                title: "Restoration of Justice",
                description: "We fight across all judicial instances to defend the rights and lawful interests of our clients."
            },
            {
                title: "Professionalism",
                description: "We develop and execute the most optimal, strategic, and forward-looking legal solutions."
            },
            {
                title: "Integrity & Loyalty",
                description: "We remain deeply faithful to the ethical and professional standards adopted by our firm."
            },
            {
                title: "Accountability",
                description: "Every consultation and legal solution provided by each team member is delivered at the highest standard of excellence."
            }
        ],
        ctaTitle: "Ready to Discuss Your Legal Matters",
        ctaText: "Contact our legal team and receive premier advisory and representation.",
        btnContactUs: "Contact Us"
    },
    services: {
        pageTitle: "Professional Legal and Advocacy Services",
        btnViewAll: "View All Services",
        items: [
            {
                title: "Legal Consultation & Advisory",
                services: [
                    "Provision of oral legal consultations",
                    "Provision of written comprehensive legal opinions"
                ]
            },
            {
                title: "Corporate Law",
                services: [
                    "Incorporation, reorganization, and liquidation of legal entities (including foreign entities)",
                    "Comprehensive corporate maintenance and compliance for enterprises"
                ]
            },
            {
                title: "Contract Law",
                services: [
                    "Contract negotiation (including with foreign counterparties)",
                    "Drafting, review, and legal structuring of contracts",
                    "Organization and oversight of notarization and certification processes"
                ]
            },
            {
                title: "Administrative Law",
                services: [
                    "Appeals against administrative acts (fines, penalties, and sanctions)",
                    "Challenging unlawful actions or omissions of administrative agencies"
                ]
            },
            {
                title: "Bankruptcy & Insolvency",
                services: [
                    "Filing voluntary bankruptcy petitions",
                    "Drafting and submitting involuntary bankruptcy claims",
                    "Legal representation and creditors' rights protection in bankruptcy proceedings"
                ]
            },
            {
                title: "Labor & Employment",
                services: [
                    "Pre-trial representation in employment and labor disputes",
                    "Court representation and litigation in labor law matters"
                ]
            },
            {
                title: "Procurement & Tenders",
                services: [
                    "Legal representation in state procurement appeals and disputes",
                    "Legal representation in private tender and commercial procurement disputes"
                ]
            },
            {
                title: "Insurance Law",
                services: [
                    "Legal support in insurance relations and claims settlement"
                ]
            },
            {
                title: "Enforcement Proceedings",
                services: [
                    "Legal supervision and representation in compulsory enforcement proceedings"
                ]
            },
            {
                title: "Arbitration Proceedings",
                services: [
                    "Representation in domestic and international arbitration proceedings"
                ]
            },
            {
                title: "Real Estate & Construction",
                services: [
                    "Legal support in construction, zoning, and real estate development"
                ]
            },
            {
                title: "Court Representation & Litigation",
                services: [
                    "Representation in property ownership and title defense disputes",
                    "Representation in land and real property disputes",
                    "Representation in intellectual property rights protection",
                    "Representation in family law and matrimonial disputes",
                    "Representation in inheritance and succession proceedings",
                    "Representation across all categories of civil, administrative, and bankruptcy cases"
                ]
            }
        ]
    },
    connect: {
        heroTitle: "Why Choose Our Firm",
        heroText: "Our seasoned legal team is dedicated to supporting you with complete confidentiality, precision, and reliable accessibility.",
        badgeLawyers: "Experienced Attorneys",
        badgeFast: "Swift Response",
        badgePrivacy: "100% Confidentiality",
        btnSendInquiry: "Submit Inquiry",
        formTitle: "Get in Touch",
        labelName: "First Name",
        placeholderName: "Your first name",
        labelLastname: "Last Name",
        placeholderLastname: "Your last name",
        labelSurname: "Middle Name",
        placeholderSurname: "Your middle name",
        labelEmail: "Email Address",
        placeholderEmail: "your.email@example.com",
        labelPhone: "Phone Number",
        placeholderPhone: "+374 ...",
        labelMessage: "Your Message",
        placeholderMessage: "Briefly describe your legal inquiry...",
        btnSubmit: "Send Message",
        btnSubmitting: "Sending...",
        toastSuccessTitle: "Message Sent Successfully",
        toastSuccessDesc: "Thank you. Our legal team will contact you shortly.",
        toastErrorTitle: "Submission Error",
        toastErrorDesc: "Failed to send message. Please try again or call us directly.",
        infoTitle: "Contact Information",
        addressTitle: "Office Address",
        addressValue: "12 N. Tigranyan St. / Tolbukhin 34, Yerevan, Armenia",
        btnSeeMap: "View on Map",
        phonesTitle: "Telephone Numbers",
        emailTitle: "Email Address",
        daysTitle: "Working Days",
        daysValue: "Monday - Friday",
        hoursTitle: "Working Hours",
        hoursValue: "09:00 - 18:00"
    },
    modal: {
        mapTitle: "Our Office Location",
        close: "Close",
        experienceClose: "Close"
    },
    testimonials: {
        badge: "CLIENT TESTIMONIALS",
        title: "What Our Clients Say About Us",
        subtitle: "Our greatest success is the gratitude of our satisfied and legally protected clients.",
        reviews: [
            {
                quote: "The LegalTitan team provided exemplary court representation, successfully restoring my property rights. I am deeply grateful for their high level of professionalism.",
                author: "Anna S.",
                role: "Sole Proprietor / Entrepreneur",
                rating: 5
            },
            {
                quote: "Our company has repeatedly turned to Legal Titan LLC regarding public and tax law matters, and we have consistently received the most optimal legal solutions.",
                author: "Armen K.",
                role: "Managing Director, Construction Company",
                rating: 5
            },
            {
                quote: "We engaged Legal Titan for ongoing legal cooperation in 2023 and continue to work together to this day. All legal issues are resolved promptly and flawlessly.",
                author: "Garik M.",
                role: "Founder, IT Company",
                rating: 5
            }
        ]
    },
    footer: {
        description: "The firm delivers premier legal and advocacy services grounded in extensive experience, utmost professionalism, and 100% confidentiality.",
        quickLinks: "QUICK LINKS",
        practiceAreas: "PRACTICE AREAS",
        contactInfo: "CONTACT INFO",
        copyright: "LegalTitan LLC. All rights reserved.",
        badgeProtection: "Professional Legal Protection in Armenia"
    }
};
